// Lucide Icons Module - AUTO-GENERATED
// This file is automatically generated by the Vite build process.
// Icons are detected from data-lucide attributes in .cshtml and .js files.

import {
    createIcons,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    Calendar,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleX,
    Download,
    Search,
} from 'lucide';

function initLucideIcons() {
    createIcons({
        icons: {
            ArrowDown,
            ArrowLeft,
            ArrowRight,
            Calendar,
            ChevronDown,
            ChevronLeft,
            ChevronRight,
            ChevronUp,
            CircleX,
            Download,
            Search,
        },
        attrs: {
            'stroke-width': 2,
            'aria-hidden': 'true',
        },
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLucideIcons);
} else {
    initLucideIcons();
}

export function refreshIcons() {
    initLucideIcons();
}

export { initLucideIcons };

if (typeof window !== 'undefined') {
    window.initLucideIcons = initLucideIcons;
    window.refreshIcons = refreshIcons;
}
